<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-tabs
        v-model="tabIndex"
        fixed-tabs
        color="white"
        background-color="black"
        slider-color="white"
        dark
      >
        <v-tab>從專案任務建立工單</v-tab>
        <v-tab>編排預算建立工單</v-tab>
      </v-tabs>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <!-- 收受部門、工作內容、預計完成時間、最後提醒時間、工單狀態-緊急 -->
              <v-col cols="12">

                <v-autocomplete
                  v-if="!form.isCreateFromNewBudget"
                  :items="projectOptions"
                  item-text="Name"
                  item-value="ID"
                  label="專案"
                  v-model="form.ProjectID"
                  @change="onProjectChanged"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="!form.isCreateFromNewBudget"
                  :items="taskOptions"
                  item-text="Name"
                  item-value="ID"
                  label="任務"
                  v-model="form.TaskID"
                  :rules="formRules.TaskID"
                ></v-autocomplete>

                <v-text-field
                  v-model="form.Budget"
                  label="預算"
                  :rules="formRules.Budget"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field>

                <!-- <v-text-field
                  v-if="!form.isCreateFromNewBudget"
                  v-model="form.EstimatedHours"
                  label="預計時數"
                  :rules="formRules.EstimatedHours"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field> -->
                
                <v-autocomplete
                  :items="departmentOptions"
                  item-text="Name"
                  item-value="ID"
                  label="收受部門"
                  v-model="form.ReceivedDepartmentID"
                  :rules="formRules.ReceivedDepartmentID"
                ></v-autocomplete>
                
                <v-autocomplete
                  :items="originalManagerOptions"
                  item-text="Name"
                  item-value="ID"
                  label="原本的負責人"
                  v-model="form.OriginalManagerID"
                  :rules="formRules.OriginalManagerID"
                ></v-autocomplete>
                
                <v-autocomplete
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="指定執行人員"
                  v-model="form.UserID"
                  :rules="formRules.UserID"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.Content"
                  rows="3"
                  label="工作內容"
                  :rules="formRules.Content"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="levelOptions"
                  item-text="Name"
                  item-value="Name"
                  label="緊急狀態"
                  v-model="form.EmergencyLevel"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <wwi-datetime-picker
                  v-model="form.Time"
                  label="工作日期"
                >
                </wwi-datetime-picker>
              </v-col>
              <v-col cols="12">
                <wwi-datetime-picker
                  v-model="form.AlertTime"
                  label="最後提醒時間"
                >
                </wwi-datetime-picker>
                <span>若該工單超過提醒時間仍未被安排，則會往上呈報至總經理❤</span>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      EmergencyLevel: "一般"
    },
    levelOptions: [{ Name: "一般" }, { Name: "緊急" }],
    tabIndex: 0
  }),
  computed: {
    formRules() {
      return {
        Content: [v => !!v || "請輸入工作內容"],
        ReceivedDepartmentID: [v => !!v || "請選擇收受部門"],
        Time: [v => !!v || "請選擇完成時間"],
        AlertTime: [v => !!v || "請選擇提醒時間"],
        OriginalManagerID: [v => !!v || "請選擇原本的負責人"],
        Budget: [
          v => v >= 0 || "預計獎金不可以是負數",
          v => parseInt(v) <= 1000000000 || "預計獎金不可超過10億"
        ],
        // EstimatedHours: [
        //   v => !!v || "請輸入預計時數",
        //   v => parseInt(v) <= 1000000000 || "預計時數不可超過10億"
        // ],
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增工單" : "編輯工單";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    departmentOptions() {
      return this.activeDepartmentList.filter(
        o => o.ID != this.myDepartment.ID
      );
    },
    editingIdx() {
      return this.$store.state.workOrder.list.findIndex(
        o => o.ID == this.editingId
      );
    },
    originalManagerOptions() {
      return this.activeUsers
        .map(o => ({ ID: o.ID, Name: o.Profile.Name }));
    },
    userOptions () {
      if (!this.form.ReceivedDepartmentID) return []
      // 只能指定收受部門的員工
      const findUserDepartmentID = user =>
        (this.userDepartments.find(o => o.UserID == user.ID) || {})
          .DepartmentID;
          
      return this.activeUsers
        .filter(o => findUserDepartmentID(o) == this.form.ReceivedDepartmentID)
        .map(o => ({ ID: o.ID, Name: o.Profile.Name }));
    },
    projectOptions() {
      let options = JSON.parse(JSON.stringify(this.projects));
      options.map(option => {
        let taskCount = this.activeTaskList
          .filter( // 篩選任務的專案
            o => o.ProjectID == option.ID
          )
          .filter( // 篩選部門
            o => o.DepartmentID == this.myDepartment.ID
          );
        if (taskCount == 0) {
          option.Name = `${option.Name} (沒有任務)`;
          option.disabled = true;
        }
        return option;
      });
      return options;
    },
    taskOptions() {
      var filter = (o => {
        if (this.form.TaskID == o.ID) return true
        if (!o.IsActive) return false
        if (o.DepartmentID != this.myDepartment.ID) return false
        if (this.form.ProjectID)
          if (o.ProjectID != this.form.ProjectID) return false;
        return true;
      })
      return this.tasks.filter(filter)
    },
    ...mapGetters(["activeDepartmentList", "myDepartment", "userDepartments", "activeUsers", "projects", "tasks", "activeTaskList"])
  },
  methods: {
    onProjectChanged() {
      // if (this.form.TaskID) return;
      let projectFirstTask = this.activeTaskList.find(
        o => o.ProjectID == this.form.ProjectID
      );
      if (!projectFirstTask) return;
      this.form.TaskID = projectFirstTask.ID;
    },
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      if (!this.form.Time) return alert("請選擇預計完成時間");
      if (!this.form.AlertTime) return alert("請選擇最後提醒時間");

      if (this.form.isCreateFromNewBudget) {
        this.form.TaskID = 0
      }

      this.form.EstimatedHours = parseInt(this.form.EstimatedHours) || 0;
      this.form.Budget = parseInt(this.form.Budget) || 0;

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.workOrder
          .edit(this, this.form)
          .then(res => {
            this.$set(
              this.$store.state.workOrder.list,
              this.editingIdx,
              res.data.result
            );
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.form.InitiatedDepartmentID = this.myDepartment.ID;
        this.$services.workOrder
          .add(this, this.form)
          .then(res => {
            this.$store.state.workOrder.list.splice(0, 0, res.data.result);
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        this.form = JSON.parse(
          JSON.stringify(this.$store.state.workOrder.list[this.editingIdx])
        );
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    let vm = this
    Promise.all([
        this.$services.workOrder.prepareData(vm),
        this.$services.project.prepareData(vm),
        this.$services.task.prepareData(vm),
    ]).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    },
    tabIndex() {
      this.form.isCreateFromNewBudget = this.tabIndex == 1
    }
  }
};
</script>